import React from 'react'
import { Space } from 'antd'
import { CheckOutlined, EyeOutlined, LockOutlined, ClockCircleOutlined } from '@ant-design/icons'
import CustomBadge from '@app/common/components/CustomBadge'

const TemplateBadge = ({
  template,
  showAudience = true,
  showPreApproval = true,
  isUsingUnifiedConvo = false,
  size = 'small',
  className = '',
  visibleAudienceBadges = ['everyone', 'internal'],
}) => {
  const renderAudienceBadge = () => {
    if (!showAudience ||
      !template.audience ||
      (visibleAudienceBadges && !visibleAudienceBadges.includes(template.audience))) {
      return null
    }

    const audienceMapping = {
      everyone: { label: 'Everyone', icon: <EyeOutlined />, color: 'gray' },
      internal: { label: isUsingUnifiedConvo ? 'Internal Only' : 'Team Conversation', icon: <LockOutlined />, color: 'blue' },
    }

    const config = audienceMapping[template.audience]
    if (!config) {
      return null
    }

    return (
      <CustomBadge key="audience" color={config.color} icon={config.icon}>
        {config.label}
      </CustomBadge>
    )
  }

  const renderPreApprovalBadge = () => {
    if (!showPreApproval || !isUsingUnifiedConvo) {
      return null
    }

    if (template.is_pre_approved) {
      return (
        <CustomBadge key="pre-approved" color="green" icon={<CheckOutlined />}>
          Approved
        </CustomBadge>
      )
    } else if (template.audience === 'everyone') {
      return (
        <CustomBadge key="requires-approval" color="amber" icon={<ClockCircleOutlined />}>
          Requires Approval
        </CustomBadge>
      )
    }

    return null
  }

  const badges = [renderAudienceBadge(), renderPreApprovalBadge()].filter(Boolean)

  if (badges.length === 0) {
    return null
  }

  return <Space size={4}>{badges}</Space>
}

export default TemplateBadge
